/* eslint-disable */
import { put, takeEvery, select, all } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { saveAs } from 'file-saver';

//Api
import {
  setCandidate,
  setCandidateByLink,
  setCandidatesCv,
  getPendingCandidates as getPendingCandidatesRequest,
  updateCandidate,
  deleteCandidate as deleteCandidateRequest,
  setCandidatesCvByLink,
  getAttachedFile,
  getUserCandidate as getUserCandidateRequest,
  deleteAttachedFile,
} from 'api/candidates';
import { getNotes } from 'api/notes';

//Actions
import {
  startAddCandidateSubmit,
  resolveAddCandidateSubmit,
  startAddCandidateByLinkSubmit,
  resolveAddCandidateByLinkSubmit,
  startApproveCandidateSubmit,
  getPendingCandidates,
  setPendingCandidates,
  resolveApproveCandidateSubmit,
  rejectPendingCandidate,
  downloadAttachedFile,
  getUserCandidate,
  setUserCandidate,
} from './actions';
import { getNotes as getNotesAction, setNotes as setNotesAction } from 'actions/notes';
import setLoading from 'actions/loading';

//
import { refetchUserJobPosts, refetchAllJobPosts } from 'modules/JobPosts/saga';
import { getCandidateData } from 'selectors/candidates';
import { getDashBoardStatistics } from 'modules/DashBoard/actions';

export function* addCandidateSaga(action: any) {
  const { role, token } = yield select(state => state.user);
  const { jobPostId, cvUrl } = action.payload;

  const candidateData = getCandidateData(action.payload, 'active');

  try {
    const candidate = yield setCandidate(candidateData, jobPostId, token);

    if (cvUrl) {
      const cvUrldata = new FormData();
      cvUrldata.append('cv', cvUrl);

      yield setCandidatesCv(cvUrldata, candidate.data.id, token);

      yield all([refetchUserJobPosts(role, token), refetchAllJobPosts(token)]);
      yield put(getDashBoardStatistics());
      yield put(resolveAddCandidateSubmit());
      yield put(push('/job-posts'));
    } else {
      yield all([refetchUserJobPosts(role, token), refetchAllJobPosts(token)]);
      yield put(getDashBoardStatistics());
      yield put(resolveAddCandidateSubmit());
      yield put(push('/job-posts'));
    }
  } catch (error) {
    yield put(resolveAddCandidateSubmit(error.response));
  }
}

export function* addCandidateByLinkSaga(action: any) {
  const { token } = yield select(state => state.user);
  const { userId, jobPostId } = action.payload.data;

  const candidateData = getCandidateData(action.payload, 'pending');

  try {
    const candidate = yield setCandidateByLink(candidateData, userId, jobPostId, token);

    if (action.payload.cvUrl) {
      const cvUrldata = new FormData();

      cvUrldata.append('cv', action.payload.cvUrl);

      yield setCandidatesCvByLink(cvUrldata, userId, candidate.data.id);
      yield put(resolveAddCandidateByLinkSubmit());
      yield put(push('/shared-link/complete'));
    } else {
      yield put(resolveAddCandidateByLinkSubmit());
      yield put(push('/shared-link/complete'));
    }
  } catch (error) {
    yield put(resolveAddCandidateByLinkSubmit(error.response));
  }
}

export function* getPendingCandidatesSaga() {
  const { token } = yield select(state => state.user);

  try {
    yield put(setLoading(true));
    const pendingCandidates = yield getPendingCandidatesRequest(token);
    if (pendingCandidates) {
      yield put(setLoading(false));
      yield put(setPendingCandidates(pendingCandidates.data));
    }
  } catch (error) {
    console.error(error.response);
  }
}

export function* approvePendingCandidateSaga(action: any) {
  const { role, token } = yield select(state => state.user);
  const { candidateId, cvFile, cvUrl } = action.payload;

  const candidateData = getCandidateData(action.payload, 'active');

  try {
    if (!cvUrl && !cvFile) {
      yield deleteAttachedFile(`recruiters/candidates/${candidateId}/cv`, token);
    } else if (cvFile) {
      const cvFiledata = new FormData();
      cvFiledata.append('cv', cvFile);

      yield setCandidatesCv(cvFiledata, candidateId, token);
    }

    yield updateCandidate(candidateData, candidateId, token);
    yield all([refetchUserJobPosts(role, token), refetchAllJobPosts(token)]);
    yield put(resolveAddCandidateSubmit());
    yield put(push('/job-posts'));
  } catch (error) {
    yield put(resolveApproveCandidateSubmit(error.response));
  }
}

export function* rejectPendingCandidateSaga(action: any) {
  const { role, token } = yield select(state => state.user);
  try {
    yield put(setLoading(true));

    yield deleteCandidateRequest(action.payload, token);
    yield all([refetchUserJobPosts(role, token), refetchAllJobPosts(token)]);

    yield put(setLoading(false));
    yield put(push('/new-candidates'));
  } catch (error) {
    console.error(error.response);
  }
}

export function* downloadAttachedFileSaga(action: any) {
  const { role, token } = yield select(state => state.user);
  const { type, id } = action.payload;
  if (type === 'cv') {
    const cv = yield getAttachedFile(`${role.toLowerCase()}s/candidates/${id}/cv`, token);
    yield saveAs(cv.data, cv.headers['x-suggested-filename']);
  } else if (type === 'unsignedOffer') {
    const unsignedOffer = yield getAttachedFile(
      `/${role.toLowerCase()}s/candidates/${id}/unsigned-offer`,
      token
    );
    yield saveAs(unsignedOffer.data, unsignedOffer.headers['x-suggested-filename']);
  } else if (type === 'signedOffer') {
    const signedOffer = yield getAttachedFile(
      `/${role.toLowerCase()}s/candidates/${id}/signed-offer`,
      token
    );
    yield saveAs(signedOffer.data, signedOffer.headers['x-suggested-filename']);
  } else if (type === 'invoice') {
    const invoice = yield getAttachedFile(
      `/${role.toLowerCase()}s/candidates/${id}/invoice`,
      token
    );
    yield saveAs(invoice.data, invoice.headers['x-suggested-filename']);
  }
}

export function* getCandidatesNotesSaga() {
  const { token } = yield select(state => state.user);
  try {
    const { data: candidatesNotes } = yield getNotes(token);

    yield put(setNotesAction(candidatesNotes));
  } catch (error) {
    console.error(error.response);
  }
}

export function* getUserCandidateSaga(action: any) {
  const { role, token } = yield select(state => state.user);
  const { id: candidateId } = action.payload;

  try {
    const userCandidate = yield getUserCandidateRequest(role, candidateId, token);
    yield put(setUserCandidate(userCandidate.data));
  } catch (error) {
    console.error(error.response);
  }
}

export default function* addCandidateSagas() {
  yield takeEvery(startAddCandidateSubmit, addCandidateSaga);
  yield takeEvery(startAddCandidateByLinkSubmit, addCandidateByLinkSaga);
  yield takeEvery(getPendingCandidates, getPendingCandidatesSaga);
  yield takeEvery(startApproveCandidateSubmit, approvePendingCandidateSaga);
  yield takeEvery(rejectPendingCandidate, rejectPendingCandidateSaga);
  yield takeEvery(downloadAttachedFile, downloadAttachedFileSaga);
  yield takeEvery(getNotesAction, getCandidatesNotesSaga);
  yield takeEvery(getUserCandidate, getUserCandidateSaga);
}
